export enum BillingsCargoTaxiUpdateStatusRequestStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsCargoTaxiUpdateStatusRequestBody = {
  status: BillingsCargoTaxiUpdateStatusRequestStatus;
  comment?: string;
};

type BillingsCargoTaxiUpdateStatusRequest = {
  billingUuid: string;
  status: BillingsCargoTaxiUpdateStatusRequestStatus;
  comment?: string;
};

export default BillingsCargoTaxiUpdateStatusRequest;
